import { render, staticRenderFns } from "./asset-tag.vue?vue&type=template&id=c2224a8e&scoped=true"
import script from "./asset-tag.vue?vue&type=script&lang=js"
export * from "./asset-tag.vue?vue&type=script&lang=js"
import style0 from "./asset-tag.vue?vue&type=style&index=0&id=c2224a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2224a8e",
  null
  
)

export default component.exports